<template>
  <div class="tblManyComp">
    <div v-if="data" class="div_tbl">
      <label v-if="!data || !data.length" class="label_nodata">Нет записей</label>
      <table v-if="data && data.length" class="tbl_1">
        <thead>
          <tr>
            <th v-for="(col, index) in model" :key="index">
              {{col.title}}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="row in data" :key="row.id">
            <td v-for="(col, index) in model" :key="index">
              {{cellHandler(row[col.data], row, col.type , col.handler)}}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'tblManyComp',
  props: {
    data: {
      type: Array,
      default: function () { return null }
    },
    model: {
      type: Object,
      required: true
    }
  },
  data: function () {
    return {
    }
  },
  created: function () {
  },
  components: {
  },
  computed: {
  },
  methods: {
    cellHandler (data, type, handler) {
      return this.$helpers.table.cellHandler(data, type, handler)
    }
  }
}
</script>

<style scoped lang="scss">

.tblManyComp {
  display: grid;
  grid-template-rows: 1fr;
  grid-template-columns: 1fr;
  width: 100%;
  min-width: 320px;
}

.div_tbl {
  margin: 32px 32px 0 32px;
  overflow: auto;
  width: auto;
}
.tbl_1 {
  border: 2px solid #bababa;
  border-radius: 9px 9px 9px 9px;
  -moz-border-radius: 9px 9px 9px 9px;
  -webkit-border-radius: 9px 9px 9px 9px;
  border-spacing: 0;
  width: 100%;
  margin-bottom: 20px;
}
.tbl_1 th:first-child {
  border: none;
}
.tbl_1 td:first-child {
  border-left: none;
}
.tbl_1 th{
  border-left: 2px solid #bababa;
  padding: 16px 24px 16px 24px;
  object-fit: contain;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  color: #ff8200;
}
.tbl_1 td{
  border-left: 2px solid #bababa;
  border-top: 2px solid #bababa;
  padding: 16px 24px 16px 24px;
  object-fit: contain;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.4px;
  text-align: center;
  color: #202020;
}

.div_tbl::-webkit-scrollbar {
    width: 10px;
}
.div_tbl::-webkit-scrollbar-track {
    border: 1px solid #bababa;
}
.div_tbl::-webkit-scrollbar-thumb {
    background: #ff8200;
}

button:active, button:hover {
  opacity: 0.5;
  cursor: pointer;
}

@media screen and (max-width: 1140px){
}
@media screen and (max-width: 960px){
}
@media screen and (max-width: 720px){
}
@media screen and (max-width: 540px){
}
@media screen and (max-width: 480px){
}
@media screen and (max-width: 320px){
}

</style>
